import { render, staticRenderFns } from "./user-input-code.vue?vue&type=template&id=63e429ac&scoped=true"
import script from "./user-input-code.vue?vue&type=script&lang=js"
export * from "./user-input-code.vue?vue&type=script&lang=js"
import style0 from "./user-input-code.vue?vue&type=style&index=0&id=63e429ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e429ac",
  null
  
)

export default component.exports